export const celsiusToFahrenheit = (celsiusTemp: number): number =>
  celsiusTemp * 1.8 + 32;
